module.exports = __webpack_public_path__ + "media/flags/am-aebf3383.svg";